import Dexie from 'dexie';

export const db = new Dexie('pinbike');

db.version(3).stores({
    fetchStatus: "key",
    cities: 'istatId, city',
    users: 'uid, email, username'
});

// La tabella Utenti e' paginata lato server: l'anagrafica non si tiene piu' nel browser.
// Con null Dexie elimina gli store e libera lo spazio occupato sui browser degli admin.
db.version(4).stores({
    fetchStatus: null,
    users: null
});
